var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"adaptive"},[_c('div',{ref:"editor",staticClass:"editorFrom",attrs:{"id":"editor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }